import {defineStore} from 'pinia'
import {ref} from 'vue'
import Srv from '@/services/GraphQLSrv'
import {FetchResponseType} from '@/types/Fetch'

export interface Entity {
  uuid: string
  title: string
  name?: string
  methods: {
    get: string
    create: string
    update: string
  }
}

export const useEntitiesStore = defineStore('entities', () => {
  const entities = ref<Entity[]>([])

  const reqEntities = async () => {
    const res = await Srv.request(
      'query',
      'entities',
      ['uuid', 'title', 'name', 'methods'],
      true,
      {
        perPage: 500,
      },
    )

    if (res.type === FetchResponseType.SUCCESS && res.data) {
      entities.value = res.data?.data
    }
  }

  // Гидрация из батч-запроса (принимает сырые данные без HTTP запроса)
  const hydrateEntities = (rawData: Entity[]) => {
    entities.value = rawData
  }

  const reqEntitiesByNames = async (names: string[]) => {
    const res = await Srv.request(
      'query',
      'entities',
      ['uuid', 'title', 'name', 'methods'],
      true,
      {
        perPage: 100,
        names,
      },
    )

    if (res.type === FetchResponseType.SUCCESS && res.data) {
      return res.data?.data || []
    }
    
    return []
  }

  return {
    entities,
    reqEntities,
    hydrateEntities,
    reqEntitiesByNames,
  }
})
